<template>
  <el-dialog :close-on-click-modal="false"  
    title="设置销售金额"
    :visible.sync="visible"
    width="540px"
    class="remarkDialog"
    :before-close="handleClose"
    
  >
    <el-form :model="detail" ref="form" label-width="120px">
      <el-form-item label="默认销售币别：">
        <div slot="label"><span style="color:red;">* </span>默认销售币别：</div>
        <el-select
          clearable
          v-model="detail.currency"
          class="input"
          size="small"
        >
          <el-option
            v-for="(value, index) in dictData['currency']"
            :key="index"
            :label="value.label"
            :value="value.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品金额：">
        <el-input
          v-model="detail.saleTotal"
          class="input"
          size="small"
          type="number"
          @change="change"
        />
      </el-form-item>
      <el-form-item label="运费：">
        <el-input
          v-model="detail.saleFare"
          class="input"
          size="small"
          type="number"
          @change="change"
        />
      </el-form-item>
      <el-form-item label="促销：">
        <el-input
          v-model="detail.saleDiscount"
          class="input"
          size="small"
          type="number"
          @change="change"
        />
      </el-form-item>
      <el-form-item label="总计：">
        {{ allTotal ? allTotal.toFixed(2) : "0.00" }}
      </el-form-item>
    </el-form>
    <div class="tip">
      <span class="store-info-icon">说明！</span>
      初始币别根据默认规则自动识别，请自行及时核对修改
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">返回</el-button>
      <el-button type="primary" @click="sure" size="small">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { editSale } from "@/api/order/all"
import { mapGetters } from "vuex"

export default {
  name: "EditSale",
  data() {
    return {
      allTotal: 0,
      detail: { currency: "", saleTotal: "", saleFare: "", saleDiscount: "" },
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    orderData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
    orderData() {
      this.allTotal = this.orderData.saleActPay
      this.detail = this._.clone(this._.pick(this.orderData, 'currency' , 'saleTotal' , 'saleFare' , 'saleDiscount' , 'appId'))
    },
  },
  methods: {
    change() {
      this.allTotal =
        Number(this.detail.saleTotal) +
        Number(this.detail.saleFare) -
        Number(this.detail.saleDiscount)
    },
    sure() {
      if (!this.detail.currency) {
        this.$message.error("请选择销售币别")
        return
      }
      editSale({
        appId: this.detail.appId,
        currency: this.detail.currency,
        saleFare: this.detail.saleFare,
        saleDiscount: this.detail.saleDiscount,
        saleTotal: this.detail.saleTotal,
      }).then((res) => {
        if (res.code !== 200) {
          this.$message.error("修改失败")
        } else {
          this.$message.success("修改成功")
          this.$emit("onOk")
        }
      })
    },
    handleClose() {
      this.$emit("onClose")
    }
  },
}
</script>

<style scoped>
.remarkDialog {
  font-size: 12px;
}

.item {
  display: flex;
  flex-wrap: wrap;
}

.tip {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
}

.tip .store-info-icon {
  display: inline-block;
  padding: 0 0 0 5px;
  background: #129ba7;
  color: #fff;
  border-radius: 2px;
  margin-right: 5px;
  line-height: 1.4;
}

.blue {
  color: #129ba7;
}
</style>
